export default function formattedPhone(phone) {
  const formatted = []
  for (let char of phone) {
    if(char !== '(' && char !== ')' && char !== '-' && char !== ' '){
      formatted.push(char)
    }
  }
  return formatted.join('')
}
